import { Injectable } from '@angular/core';
import
{ ActivatedRouteSnapshot, Router, RouterStateSnapshot, Routes, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { map } from 'rxjs/operators';
import { NavigationService } from 'app/core/navigation/navigation.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard 
{
    constructor(
        private _authService: AuthService,
        private _userService: UserService,
        private _navigationService: NavigationService,
        private _router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean
    {
        return this._check(state);
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree
    {
        return this._check(state);
    }

    private _check(state: RouterStateSnapshot): Observable<boolean>
    {
        // const redirectUrl = state.url === '/sign-out' ? '/' : state.url;

        return combineLatest([
            this._authService.authenticated$,
            this._navigationService.navigation$,
            this._userService.currentUser$,
        ]).pipe(
            map(x =>
            {
                const authenticated: boolean = x[0];

                const url: string = (
                    state.url.startsWith('/')
                        ? state.url.substring(1)
                        : state.url
                ).toLowerCase();

                if (
                    !url.startsWith('apps') &&
                    !url.startsWith('pages') &&
                    !url.startsWith('admin')
                )
                    return true;

                if (authenticated)
                    return true;

                this._router.navigate(['/sign-in']);

                return false;
            })
        );
    }

    public static AddGuard(routes: Routes): Routes
    {
        for (const route of routes)
        {
            route.canActivate = [AuthGuard];
            route.canActivateChild = [AuthGuard];
        }

        return routes;
    }
}
